export default "__VITE_ASSET__BhiVT8VS__"